module.exports = __webpack_public_path__ + "img/dis3.16f622bf.png";